import {
  fetchAdaptationLibrary,
  fetchAdaptationLibraryFilters,
  fetchAdaptationLibraryItem,
} from '../service/adaptationLibrary.service'
import { useQuery } from '@tanstack/react-query'
import { useAtomValue } from 'jotai'
import { isAuthenticatedAtom } from '@app/state/authAtom'
import {
  AdaptationLibraryItem,
  AdaptionLibraryResponse,
  AdaptationLibraryFilter,
} from '../utils/adaptationLibrary.types'

export function useFetchAdaptationLibrary(
  clientName: string,
  pageNumber: number,
  pageSize: number,
  filter: AdaptationLibraryFilter,
) {
  const isAuthenticated = useAtomValue(isAuthenticatedAtom)

  return useQuery<AdaptionLibraryResponse>({
    queryKey: ['adaptation-library', clientName, pageNumber, JSON.stringify(filter), pageSize],
    queryFn: () => fetchAdaptationLibrary(pageNumber, pageSize, filter),
    enabled: isAuthenticated && Boolean(clientName),
  })
}

export function useFetchAdaptationLibraryItem(id: string) {
  const isAuthenticated = useAtomValue(isAuthenticatedAtom)

  return useQuery<AdaptationLibraryItem>({
    queryKey: ['adaptation-library-item', id],
    queryFn: () => fetchAdaptationLibraryItem(id),
    enabled: isAuthenticated && Boolean(id),
  })
}

export function useFetchAdaptationFilters(clientName: string) {
  const isAuthenticated = useAtomValue(isAuthenticatedAtom)

  return useQuery<AdaptationLibraryFilter>({
    queryKey: ['adaptation-library-filters', clientName],
    queryFn: () => fetchAdaptationLibraryFilters(),
    enabled: isAuthenticated && Boolean(clientName),
  })
}
